import Transformer from './../transformer'

export default class SinisterTransformer extends Transformer {
  static fetch(rawSinister) {

    const sinisterRoadData = rawSinister.sinister.sinister_road_data
    return {
      id: rawSinister.id,
      description: rawSinister.description,
      requisitionNumber: rawSinister.requisition_number,
      totalAmount: rawSinister.total_amount,
      typeOfDamage: rawSinister.type_of_damage,
      // Sinister data
      sinisterNumber: rawSinister.sinister.sinister_data.sinister_number,
      folioJB: rawSinister.sinister.sinister_data.folio_jb,
      assignmentDate: rawSinister.sinister.sinister_data.date_assignment,
      occurredDate: rawSinister.sinister.sinister_data.date_occurred,
      // Road sinister data
      highway: rawSinister.sinister.sinister_road_data.highway.highway_name,
      highwaySection: rawSinister.sinister.sinister_road_data.highway_section.highway_section,
      body: rawSinister.sinister.sinister_road_data.body,
      kilometer: rawSinister.sinister.sinister_road_data.kilometer,
      meter: rawSinister.sinister.sinister_road_data.meter,
      reportNumberInbursaOne: rawSinister.sinister.sinister_road_data.report_number_inbursa_one,
      reportNumberInbursaTwo: rawSinister.sinister.sinister_road_data.report_number_inbursa_two,

      sinisterDataId: sinisterRoadData.id,
      loadingCapacity: sinisterRoadData.loading_capacity,
      logistics: sinisterRoadData.logistics,
      operationalCapacity: sinisterRoadData.operational_capacity,
      protectiveEquipment: sinisterRoadData.protective_equipment,
      fileLoadingCapacity: sinisterRoadData.file_loading_capacity,
      dateLoadingCapacity: sinisterRoadData.file_loading_capacity ? sinisterRoadData.file_loading_capacity.date_content : null,
      fileLogistics: sinisterRoadData.file_logistics,
      dateLogistics: sinisterRoadData.file_logistics ? sinisterRoadData.file_logistics.date_content : null,
      fileOperationalCapacity: sinisterRoadData.file_operational_capacity,
      dateOperationalCapacity: sinisterRoadData.file_operational_capacity ? sinisterRoadData.file_operational_capacity.date_content : null,
      fileProtectiveEquipment: sinisterRoadData.file_protective_equipment,
      dateProtectiveEquipment: sinisterRoadData.file_protective_equipment ? sinisterRoadData.file_protective_equipment.date_content : null,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/sinister/sinisterInWP.js